export default "__VITE_ASSET__BJV032md__"